import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import GroupsTable from "./GroupsTable";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
    boxSizing: "border-box",
  },
  title: {
    color: theme.colors.Violet,
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    fontSize: "24px",
    marginBottom: "6px",
  },
  description: {
    color: theme.colors.DodgerBlue,
    fontFamily: theme.fontFamily.MARKPROBOOK,
    fontSize: "14px",
    marginBottom: "24px",
  },
}));

function RoleGroupsPage() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.title}>Role Groups</div>
      <div className={classes.description}>
        Manage backoffice permission groups, their capabilities, and members.
      </div>
      <GroupsTable />
    </div>
  );
}

export default RoleGroupsPage;
